export const SET_IMPERSONATING_STATE_KEY = 'SET_IMPERSONATING_STATE_KEY';
export const GET_CUSTOMER_STATE_EDGE = 'GET_CUSTOMER_STATE_EDGE';
export const PUT_CUSTOMER_STATE_EDGE = 'PUT_CUSTOMER_STATE_EDGE';
export const GET_TRUELAYER_URL = 'GET_TRUELAYER_URL';
export const GET_DOCUMENT_FEEDBACK = 'GET_DOCUMENT_FEEDBACK';
export const GET_OFFERS = 'GET_OFFERS';
export const POST_SELECT_OFFER = 'POST_SELECT_OFFER';
export const GET_QUALIFIED_LEAD = 'GET_QUALIFIED_LEAD';
export const SET_CUSTOMER_STATUS = 'SET_CUSTOMER_STATUS';
export const SET_NEW_STATE_KEY = 'SET_NEW_STATE_KEY';
export const SET_APPLICATION_DATA = 'SET_APPLICATION_DATA';
